/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { CloudResourceProvider, ResourceStatus } from "~/generated/graphql";
import { SvgName } from "~/tools/types";

export function getCloudResourceStatusMessage(status: ResourceStatus) {
  if (status === ResourceStatus.ConnectionLost) {
    return "Lost Connection";
  } else {
    return "Online";
  }
}

export function getCloudResourceColorContext(status: ResourceStatus) {
  if (status === ResourceStatus.ConnectionLost) {
    return "danger";
  } else {
    return "success";
  }
}

export function getCloudResourceStatusIconName(status: ResourceStatus) {
  if (status === ResourceStatus.ConnectionLost) {
    return "cloudOffline";
  } else {
    return "cloud";
  }
}

export function getProviderIcon(provider: CloudResourceProvider): SvgName {
  switch (provider) {
    case CloudResourceProvider.Azure:
      return "azure";
    case CloudResourceProvider.Aws:
      return "aws";
    case CloudResourceProvider.Gc:
      return "gcp";
    case CloudResourceProvider.Ibm:
      return "ibmCloud";
    case CloudResourceProvider.Other:
      return "cloudQuestionMark";
    default:
      return "cloudQuestionMark";
  }
}

const VMResourceTypes = [
  { type: "ec2", subtype: "instance" },
  { type: "microsoft.compute", subtype: "virtualmachines" },
  { type: "compute.googleapis.com", subtype: "instances" },
  { type: "is", subtype: "instance" },
  { type: "other", subtype: "other" },
];

export const VMsOnlyFilter = VMResourceTypes.map((item) =>
  concatTypeAndSubtype(item)
);

function concatTypeAndSubtype(item: { type: string; subtype: string }): string {
  if (item.type === item.subtype) {
    return item.type;
  }

  return `${item.type}/${item.subtype}`;
}

export function isVirtualMachine(item: {
  type: string;
  subtype: string;
}): boolean {
  return VMResourceTypes.some(
    (vmType) => vmType.type === item.type && vmType.subtype === item.subtype
  );
}
